/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { useState } from 'react'
import {
    AppBar,
    Badge,
    Dialog,
    DialogActions,
    DialogTitle,
    DialogContent,
    Grid,
    Typography,
    ListItemIcon,
    Menu,
    MenuItem,
    ListItem,
} from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import MenuIconRight from '../../Assets/Icons/Navigation-Right.png'
import styles from './Navbar.module.css'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { NavLink, useNavigate, useLocation } from 'react-router-dom'
import { CloseIcon, NotificationsOutlinedIcon } from '../../Assets'
import { useWindowDimensions } from '../../Hooks'
import { AvatarCmp } from '..'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useAlert from '../../Hooks/useAlert/useAlert'
import { LoaderCmp } from '..'
import { GetNotificationCount } from '../../Store/Actions/NotificationAction'
import BuildLinkLogo from '../../Assets/Images/BuildLinkCompleteLogo.png'
import BuildStudiologo from '../../Assets/Images/BuildStudiologo-gold.png'
import BuildBidLogo from '../../Assets/Images/Build-BID2.png'
import LinksuranceLogo from '../../Assets/Images/linksurance-logo.png'
import { postMethodMultiPartHeader } from '../../Utils/response'
import MessageIcon from '@mui/icons-material/Message'
import { LogoutAction } from '../../Store/Actions/AuthActions'
import Logout from '@mui/icons-material/Logout'
import Button from '@mui/material/Button'
import Divider from '@mui/material/Divider'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { validation } from '../../Config'
import { DropDownCmp, InputCmp, TextAreaCmp } from '../../Components'
import { Feedback } from '@mui/icons-material'
import FeedbackSuccessPopover from './FeedbackSuccessPopover'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

function PopupDialog({
    open = true,
    onConfirm,
    onClose,
    title = 'Submit Feedback',
    setOpenSuccessPopup,
    setFeedbackType,
}) {
    const { setAlert } = useAlert()
    const [isLoading, setIsLoading] = useState(false)
    const {
        handleSubmit,
        control,
        watch,
        setValue,
        formState: { errors },
        reset,
    } = useForm({
        mode: 'onChange',
        defaultValues: {
            subject: '',
            description: '',
            type: '',
            image: '',
        },
        resolver: yupResolver(validation.feedbackValidation),
    })

    const handleClose = () => {
        reset()
        onClose()
    }
    const onSubmit = async (obj) => {
        setIsLoading(true)
        const formData = new FormData()
        for (let key in obj) {
            formData.append(key, obj[key])
        }

        try {
            const response = await postMethodMultiPartHeader('feedback', obj)
            if (response.data.success) {
                setAlert(response.data.message)
                handleClose()
                setFeedbackType('success')
                setOpenSuccessPopup(true)
            } else {
                setAlert(response.data.message)
                handleClose()
                setFeedbackType('error')
                setOpenSuccessPopup(true)
            }
            setIsLoading(false)
        } catch (error) {
            setAlert(error.message)
            setIsLoading(false)
            handleClose()
            setFeedbackType('error')
            setOpenSuccessPopup(true)
        }
    }
    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{ sx: { borderRadius: 5 } }}
        >
            <DialogTitle
                sx={{
                    color: '#000',
                    fontWeight: 'bold',
                    // textAlign: 'left',
                    textTransform: 'none',
                    position: 'relative',
                }}
            >
                {title}
                <IconButton
                    className="!absolute top-3 right-3"
                    onClick={handleClose}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} sx={{ padding: '5px 0px' }}>
                        <Grid item xs={12}>
                            <DropDownCmp
                                label={'Category'}
                                name="type"
                                placeholder="Select Type"
                                disableClearable
                                freeSolo={false}
                                options={[
                                    'Build Bids',
                                    'Build Studio',
                                    'Profile',
                                    'Chat',
                                    'Pro Connections',
                                    'General Feedback',
                                ]}
                                control={control}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <InputCmp
                                name="subject"
                                control={control}
                                label={'Subject'}
                                placeholder="Please enter your subject"
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="subtitle1" gutterBottom>
                                Attachment{' '}
                                <span style={{ color: 'grey' }}>
                                    (Optional)
                                </span>
                            </Typography>
                            <input
                                type="file"
                                id="file-upload"
                                style={{ display: 'none' }}
                                accept="image/png, image/jpeg, image/jpg, image/gif"
                                onChange={(e) => {
                                    const file = e.target.files[0]
                                    if (file) {
                                        // Check file size
                                        if (file.size > 3 * 1024 * 1024) {
                                            setAlert(
                                                'File size should not exceed 3MB',
                                                'error'
                                            )
                                            return
                                        }

                                        // Check file type
                                        const allowedTypes = [
                                            'image/jpeg',
                                            'image/jpg',
                                            'image/png',
                                            'image/gif',
                                        ]
                                        if (!allowedTypes.includes(file.type)) {
                                            setAlert(
                                                'File must be of type: jpeg, jpg, png, or gif',
                                                'error'
                                            )
                                            return
                                        }

                                        setValue('image', file)
                                    }
                                }}
                            />
                            <label htmlFor="file-upload">
                                <Button
                                    variant="outlined"
                                    component="span"
                                    fullWidth
                                    sx={{ textTransform: 'capitalize' }}
                                >
                                    Upload File
                                </Button>
                            </label>
                            {watch('image') && (
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    mt={1}
                                >
                                    Selected File: {watch('image')?.name}
                                </Typography>
                            )}
                        </Grid>
                        <Grid item xs={12}>
                            <TextAreaCmp
                                label="Message"
                                control={control}
                                name="description"
                                rows="4"
                                placeholder="Message comes here..."
                            />
                        </Grid>
                    </Grid>
                    <DialogActions>
                        <Button
                            onClick={handleClose}
                            variant="contained"
                            color="primary"
                            sx={{
                                textTransform: 'capitalize',
                                backgroundColor: 'var(--primary-color)',
                                '&:hover': {
                                    backgroundColor: '#00467b',
                                },
                            }}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            // onClick={onConfirm}
                            color="success"
                            autoFocus
                            sx={{ textTransform: 'capitalize' }}
                            type="submit"
                            disabled={isLoading}
                        >
                            Submit
                        </Button>
                    </DialogActions>
                </form>
            </DialogContent>
        </Dialog>
    )
}

const Navbar = () => {
    const { profileDetails, profileDetailsLoading } = useSelector(
        (state) => state.UserProfileReducer
    )

    const { width } = useWindowDimensions()

    return width >= '768' ? (
        <>
            <AppNavBar
                profileDetails={profileDetails}
                profileDetailsLoading={profileDetailsLoading}
            />
        </>
    ) : (
        <AppMobileNavBar
            profileDetails={profileDetails}
            profileDetailsLoading={profileDetailsLoading}
        />
    )
}

// const goToShop = () => {
//     const userData = JSON.parse(localStorage.getItem('userData'))
//     const shopUserData = {
//         company_name: userData.company_name,
//         all_roles: userData.all_roles,
//         name: userData.name,
//         email: userData.email,
//         company_email: userData.company_email,
//         token: userData.token,
//         first_name: userData.first_name,
//         last_name: userData.last_name,
//         phone: userData.phone,
//         street_address: userData.street_address,
//         zip: userData.zip,
//     }

//     const str = `?data=${encodeURIComponent(JSON.stringify(shopUserData))}`
//     window.location.href = `${SHOP_URL}/login${str}`
// }

const AppNavBar = ({ profileDetails, profileDetailsLoading }) => {
    const navigate = useNavigate()
    const location = useLocation()
    const [openPopup, setOpenPopup] = useState(false)
    const [openSuccessPopup, setOpenSuccessPopup] = useState(false)
    const [feedbackType, setFeedbackType] = useState('success')
    const [buildBidAnchorEl, setBuildBidAnchorEl] = useState(null)
    const [buildBidMenuType, setBuildBidMenuType] = useState('jobs') // 'jobs' or 'mybids'
    
    const handleBuildBidMouseEnter = (event) => {
        setBuildBidAnchorEl(event.currentTarget)
    }
    
    const handleBuildBidMouseLeave = () => {
        // Add a small delay to prevent menu from closing immediately
        setTimeout(() => {
            setBuildBidAnchorEl(null)
        }, 100)
    }
    
    const handleMenuMouseEnter = () => {
        // Clear the timeout when hovering over menu
        setBuildBidAnchorEl(buildBidAnchorEl)
    }
    
    const handleMenuMouseLeave = () => {
        setBuildBidAnchorEl(null)
    }
    
    const handleBuildBidOptionClick = (type) => {
        setBuildBidMenuType(type)
        localStorage.setItem('buildBidMenuType', type)
        
        // Dispatch custom event to notify SideBarNav
        window.dispatchEvent(new CustomEvent('buildBidMenuChange', {
            detail: { menuType: type }
        }))
        
        // Navigate to different routes based on menu type
        if (type === 'jobs') {
            navigate('/buildbid/jobs')
        } else if (type === 'mybids') {
            navigate('/buildbid/mybids')
        }
        
        setBuildBidAnchorEl(null)
    }
    const popupHandler = () => {
        setOpenSuccessPopup(false)
        setOpenPopup(!openPopup)
    }
    const notifyHandler = () => {
        navigate('/notification')
    }
    const [notificationCounter, setNotificationCounter] = useState(0)
    const dispatch = useDispatch()
    const { setAlert } = useAlert()
    const { notificationCountdata } = useSelector(
        (state) => state.GetNotificationCountReducer
    )

    useEffect(() => {
        dispatch(GetNotificationCount(setAlert))
    }, [])

    useEffect(() => {
        if (notificationCountdata) {
            setNotificationCounter(notificationCountdata)
        }
    }, [notificationCountdata])

    // Load saved build bid menu type
    useEffect(() => {
        const savedMenuType = localStorage.getItem('buildBidMenuType')
        if (savedMenuType) {
            setBuildBidMenuType(savedMenuType)
        }
    }, [])

    const { all_roles } = profileDetails || []
    const logoutHandler = () => {
        dispatch(LogoutAction(navigate))
    }

    const buttonList = [
        // {
        //     btnName: 'Go to Shop',
        //     onClick: goToShop,
        //     icon: <ShoppingCartOutlinedIcon />,
        //     count: null,
        // },
        {
            menu: 'feedback',
            to: 'feedback',
            btnName: 'Feedback',
            onClick: popupHandler,
            icon: (
                <Feedback
                    className={
                        location.pathname.includes('feedback')
                            ? styles.activeMenu
                            : styles.inActiveMenu
                    }
                />
            ),
            // count: null,
        },

        {
            menu: 'notification',
            btnName: 'Notifications',
            to: 'notification',
            onClick: notifyHandler,
            // onClick: () => {
            //     setCurrentMenu('notification')
            //     navigate('notification')
            // },
            icon: (
                <NotificationsOutlinedIcon
                    className={
                        location.pathname.includes('notification')
                            ? styles.activeMenu
                            : styles.inActiveMenu
                    }
                />
            ),
            count: notificationCounter,
        },
        {
            btnName: 'Logout',
            onClick: logoutHandler,
            icon: <Logout className={styles.inActiveMenu} />,
            count: null,
        },
    ]
    return (
        <>
            <AppBar
                position="static"
                sx={{
                    background: 'white',
                }}
                elevation={0}
            >
                <Box
                    sx={{
                        padding: '0.8rem',
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'start',
                        }}
                    >
                        <img
                            src={
                                location.pathname.includes('buildbid')
                                    ? BuildBidLogo
                                    : location.pathname.includes('buildstudio')
                                      ? BuildStudiologo
                                      : location.pathname.includes('buildinsurance')
                                        ? LinksuranceLogo
                                        : BuildLinkLogo
                            }
                            alt="icon"
                            className={styles.menuIcon}
                            width={100}
                            height={40}
                            style={{
                                objectFit: 'cover',
                                marginRight: '2rem',
                            }}
                        />
                        <NavLink
                            to="/dashboard"
                            className={({ isActive }) =>
                                isActive || location.pathname === '/dashboard'
                                    ? styles.activeClassName
                                    : styles.inActiveClassName
                            }
                        >
                            <ListItemButton className="">
                                <ListItemText primary="Dashboard" />
                            </ListItemButton>
                        </NavLink>

                        {all_roles &&
                            (all_roles.includes(
                                'Pro Connection - Connections'
                            ) ||
                                all_roles.includes(
                                    'Pro Connection - My Project Gallery'
                                )) && (
                                <NavLink
                                    to="/buildlink/proconnection"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.includes('buildlink')
                                            ? styles.activeClassName
                                            : styles.inActiveClassName
                                    }
                                >
                                    <ListItemButton className="">
                                        <ListItemText primary="Pro Connections" />
                                    </ListItemButton>
                                </NavLink>
                            )}
                        {all_roles &&
                            (all_roles.includes('Build Bid - Jobs') ||
                                all_roles.includes('Build Bid - My Bids')) && (
                                <Box
                                    onMouseEnter={handleBuildBidMouseEnter}
                                    onMouseLeave={handleBuildBidMouseLeave}
                                    sx={{ position: 'relative' }}
                                >
                                    <ListItemButton
                                        className={
                                            location.pathname.includes('buildbid')
                                                ? styles.activeClassName
                                                : styles.inActiveClassName
                                        }
                                    >
                                        <ListItemText primary="Build Bid" />
                                        <KeyboardArrowDownIcon 
                                            sx={{ 
                                                fontSize: '16px',
                                                transition: 'transform 0.2s',
                                                transform: buildBidAnchorEl ? 'rotate(180deg)' : 'rotate(0deg)'
                                            }} 
                                        />
                                    </ListItemButton>
                                    <Menu
                                        anchorEl={buildBidAnchorEl}
                                        open={Boolean(buildBidAnchorEl)}
                                        onClose={() => setBuildBidAnchorEl(null)}
                                        anchorOrigin={{
                                            vertical: 'bottom',
                                            horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                            vertical: 'top',
                                            horizontal: 'left',
                                        }}
                                        MenuListProps={{
                                            onMouseEnter: handleMenuMouseEnter,
                                            onMouseLeave: handleMenuMouseLeave,
                                            style: { pointerEvents: 'auto' }
                                        }}
                                        slotProps={{
                                            paper: {
                                                onMouseEnter: handleMenuMouseEnter,
                                                onMouseLeave: handleMenuMouseLeave,
                                                style: { pointerEvents: 'auto' }
                                            }
                                        }}
                                        disableScrollLock
                                        keepMounted
                                    >
                                        <MenuItem 
                                            onClick={() => handleBuildBidOptionClick('jobs')}
                                            sx={{ 
                                                padding: '12px 30px',
                                                // fontSize: '16px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            Create Jobs
                                        </MenuItem>
                                        <MenuItem 
                                            onClick={() => handleBuildBidOptionClick('mybids')}
                                            sx={{ 
                                                padding: '12px 30px',
                                                // fontSize: '16px',
                                                fontWeight: '500'
                                            }}
                                        >
                                            Search Jobs
                                        </MenuItem>
                                    </Menu>
                                </Box>
                            )}
                        {all_roles &&
                            all_roles.includes('Build Studio - Jobs') && (
                                <NavLink
                                    to="/buildstudio/jobs"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.includes('buildstudio')
                                            ? styles.activeClassName
                                            : styles.inActiveClassName
                                    }
                                >
                                    <ListItemButton className="">
                                        <ListItemText primary="Build Studio" />
                                    </ListItemButton>
                                </NavLink>
                            )}

                        {all_roles &&
                            (all_roles.includes('Shop - Products') ||
                                all_roles.includes('Shop - Orders')) && (
                                <NavLink
                                    to="/buildshop/viewproduct"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.includes('buildshop')
                                            ? styles.activeClassName
                                            : styles.inActiveClassName
                                    }
                                >
                                    <ListItemButton className="">
                                        <ListItemText primary="Build Shop" />
                                    </ListItemButton>
                                </NavLink>
                            )}

                        {all_roles &&
                            all_roles.includes('Linksurance - Orders') && (
                                <NavLink
                                    to="/buildinsurance/orders/general"
                                    className={({ isActive }) =>
                                        isActive || location.pathname.includes('buildinsurance')
                                            ? styles.activeClassName
                                            : styles.inActiveClassName
                                    }
                                >
                                    <ListItemButton className="">
                                        <ListItemText primary="Linksurance" />
                                    </ListItemButton>
                                </NavLink>
                            )}
                    </Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    ></Box>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '1rem',
                            width: 'fit-content',
                        }}
                    >
                        {/* <section className={styles.shoplink}>
                        <a onClick={goToShop}>Go to Shop</a>
                        <ShoppingCartOutlinedIcon
                            sx={{ color: 'white', marginRight: '0.2rem' }}
                            fontSize="small"
                        />
                    </section>

                    <section className={styles.navIconWrapper}>
                        <div>
                            <a href="#">Noifications</a>
                            <NotificationsOutlinedIcon fontSize={'small'} />
                        </div>
                    </section> */}
                        {/* 
                        <Button
                            sx={{
                                backgroundColor: 'white !important',
                                textTransform: 'capitalize',
                                paddingInline: 0,
                                color: '#000',
                                textWrap: 'nowrap',
                                '& .end-icon': {
                                    backgroundColor: '#f2faf9',
                                    color: '#005699',
                                },
                                ':hover': {
                                    color: '#005699',
                                    '& .end-icon': {
                                        backgroundColor: '#005699',
                                        color: 'white !important',
                                    },
                                },
                            }}
                            variant="text"
                            // className={styles.button}
                            aria-label={'Chat'}
                            size="large"
                            type="button"
                            endIcon={
                                <Badge
                                    badgeContent={
                                        profileDetails?.unread_messages || 0
                                    }
                                    color="primary"
                                >
                                    <IconButton
                                        className="end-icon"
                                        disableRipple
                                        disableFocusRipple
                                    >
                                        <MessageIcon />
                                    </IconButton>
                                </Badge>
                            }
                            onClick={() => navigate('/chat')}
                        >
                            Chat
                        </Button> */}
                        <NavLink
                            to="/chat"
                            className={({ isActive }) =>
                                isActive || location.pathname.includes('chat')
                                    ? styles.activeClassName
                                    : styles.inActiveClassName
                            }
                            style={{
                                height: '48px',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <ListItemButton className="">
                                <ListItemText primary="Chat" />
                                <ListItemIcon
                                    style={{ padding: '0px', minWidth: '0px' }}
                                >
                                    <Badge
                                        badgeContent={
                                            profileDetails?.unread_messages || 0
                                        }
                                        color="primary"
                                    >
                                        <IconButton
                                            className="end-icon"
                                            disableRipple
                                            disableFocusRipple
                                        >
                                            <MessageIcon
                                                className={
                                                    location.pathname.includes('chat')
                                                        ? styles.activeMenu
                                                        : styles.inActiveMenu
                                                }
                                            />
                                        </IconButton>
                                    </Badge>
                                </ListItemIcon>
                            </ListItemButton>
                        </NavLink>

                        {buttonList.map((m, i) => (
                            // <NavLink
                            //     key={i}
                            //     to={m.to}
                            //     className={({ isActive }) =>
                            //         isActive || currentMenu === m.menu
                            //             ? styles.activeClassName
                            //             : styles.inActiveClassName
                            //     }
                            //     style={{
                            //         height: '48px',
                            //         display: 'flex',
                            //         alignItems: 'center',
                            //     }}
                            //     onClick={() => m.countonClick()}
                            // >
                            <ListItemButton
                                key={i}
                                className={
                                    location.pathname.includes(m.menu)
                                        ? styles.activeClassName
                                        : styles.inActiveClassName
                                }
                                style={{
                                    height: '48px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                                onClick={m.onClick}
                            >
                                <ListItemText primary={m.btnName} />
                                <ListItemIcon
                                    style={{
                                        padding: '0px',
                                        minWidth: '0px',
                                    }}
                                >
                                    <Badge
                                        badgeContent={m.count || 0}
                                        color="primary"
                                    >
                                        <IconButton
                                            className="end-icon"
                                            disableRipple
                                            disableFocusRipple
                                        >
                                            {m.icon}
                                        </IconButton>
                                    </Badge>
                                </ListItemIcon>
                            </ListItemButton>
                            // </NavLink>
                            // <Button
                            //     key={i}
                            //     sx={{
                            //         backgroundColor: 'white !important',
                            //         textTransform: 'capitalize',
                            //         paddingInline: 0,
                            //         color: '#000',
                            //         textWrap: 'nowrap',
                            //         '& .end-icon': {
                            //             backgroundColor: '#f2faf9',
                            //             color: '#005699',
                            //         },
                            //         ':hover': {
                            //             color: '#005699',
                            //             '& .end-icon': {
                            //                 backgroundColor: '#005699',
                            //                 color: 'white !important',
                            //             },
                            //         },
                            //     }}
                            //     variant="text"
                            //     // className={styles.button}
                            //     aria-label={m.btnName}
                            //     size="large"
                            //     type="button"
                            //     endIcon={
                            //         <Badge
                            //             badgeContent={m.count || 0}
                            //             color="primary"
                            //         >
                            //             <IconButton className="end-icon">
                            //                 {m.icon}
                            //             </IconButton>
                            //         </Badge>
                            //     }
                            //     onClick={m.onClick}
                            // >
                            //     {m.btnName}
                            // </Button>
                        ))}

                        <Divider orientation="vertical" />
                        {/* 
                    <div className={styles.navAvatarName}>
                        {profileDetailsLoading ? (
                            <LoaderCmp />
                        ) : (
                            <>
                                <p>{`${profileDetails?.first_name} ${profileDetails?.last_name}`}</p>
                                <small>{profileDetails?.type}</small>
                            </>
                        )}
                    </div> */}
                        <AvatarCmp
                            img={`${profileDetails?.ImgURL}${profileDetails?.image}`}
                            firstLetter={profileDetails?.first_name}
                            profileDetails={profileDetails}
                        />
                    </Box>
                </Box>
            </AppBar>
            <PopupDialog
                open={openPopup}
                onConfirm={popupHandler}
                onClose={popupHandler}
                setOpenSuccessPopup={setOpenSuccessPopup}
                setFeedbackType={setFeedbackType}
            />
            <FeedbackSuccessPopover
                open={openSuccessPopup}
                setIsOpen={setOpenSuccessPopup}
                type={feedbackType}
            />
        </>
    )
}

const AppMobileNavBar = ({ profileDetails, profileDetailsLoading }) => {
    const dispatch = useDispatch()
    const { setAlert } = useAlert()

    useEffect(() => {
        dispatch(GetNotificationCount(setAlert))
    }, [])
    const [navbarOpen, setNavbarOpen] = useState(false)

    const handleNavbarOpen = () => {
        setNavbarOpen(!navbarOpen)
    }

    const closeMenu = () => {
        setNavbarOpen(false)
    }
    const { all_roles } = profileDetails || []

    return (
        <AppBar
            position={navbarOpen ? 'absolute' : 'static'}
            sx={{
                background: 'white',
            }}
        >
            <Box
                sx={{
                    padding: '0.8rem',
                    overflow: 'hidden',
                    display: 'flex',
                    justifyContent: 'space-between',
                }}
            >
                <img
                    src={BuildLinkLogo}
                    alt="icon"
                    className={styles.menuIcon}
                    width={100}
                    height={40}
                    style={{
                        objectFit: 'cover',
                    }}
                />
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <section className={styles.navIconWrapper}>
                        <div>
                            <NotificationsOutlinedIcon fontSize={'small'} />
                        </div>
                    </section>
                    <IconButton onClick={handleNavbarOpen}>
                        <img src={MenuIconRight} alt="icon" />
                    </IconButton>
                </Box>
            </Box>

            {navbarOpen && (
                <Box
                    sx={{
                        margin: '0.8rem',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        height: 'calc(100vh - 70px)',
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                        }}
                    >
                        <div className={styles.navAvatarName}>
                            {profileDetailsLoading ? (
                                <LoaderCmp />
                            ) : (
                                <>
                                    <p>{`${profileDetails?.first_name} ${profileDetails?.last_name}`}</p>
                                    <small>{profileDetails?.type}</small>
                                </>
                            )}
                        </div>
                        <AvatarCmp
                            img={`${profileDetails?.ImgURL}${profileDetails?.image}`}
                            firstLetter={profileDetails?.first_name}
                        />
                    </Box>

                    <NavLink
                        to="/dashboard"
                        className={({ isActive }) =>
                            isActive
                                ? styles.activeClassName
                                : styles.inActiveClassName
                        }
                        onClick={closeMenu}
                    >
                        <ListItemButton>
                            <ListItemText primary="Dashboard" />
                        </ListItemButton>
                    </NavLink>
                    {all_roles &&
                        (all_roles.includes('Pro Connection - Connections') ||
                            all_roles.includes(
                                'Pro Connection - My Project Gallery'
                            )) && (
                            <NavLink
                                to="/buildlink/proconnection"
                                className={({ isActive }) =>
                                    isActive
                                        ? styles.activeClassName
                                        : styles.inActiveClassName
                                }
                                onClick={closeMenu}
                            >
                                <ListItemButton>
                                    <ListItemText primary="Pro Connections" />
                                </ListItemButton>
                            </NavLink>
                        )}
                    {all_roles &&
                        (all_roles.includes('Build Bid - Jobs') ||
                            all_roles.includes('Build Bid - My Bids')) && (
                            <NavLink
                                to="/buildbid/jobs"
                                className={({ isActive }) =>
                                    isActive
                                        ? styles.activeClassName
                                        : styles.inActiveClassName
                                }
                                onClick={closeMenu}
                            >
                                <ListItemButton>
                                    <ListItemText primary="Build Bid" />
                                </ListItemButton>
                            </NavLink>
                        )}
                    {all_roles && all_roles.includes('Build Studio - Jobs') && (
                        <NavLink
                            to="/buildstudio/jobs"
                            className={({ isActive }) =>
                                isActive
                                    ? styles.activeClassName
                                    : styles.inActiveClassName
                            }
                            onClick={closeMenu}
                        >
                            <ListItemButton>
                                <ListItemText primary="Build Studio" />
                            </ListItemButton>
                        </NavLink>
                    )}

                    {all_roles &&
                        (all_roles.includes('Shop - Products') ||
                            all_roles.includes('Shop - Orders')) && (
                            <NavLink
                                to="/buildshop/viewproduct"
                                className={({ isActive }) =>
                                    isActive
                                        ? styles.activeClassName
                                        : styles.inActiveClassName
                                }
                                onClick={closeMenu}
                            >
                                <ListItemButton>
                                    <ListItemText primary="Build Shop" />
                                </ListItemButton>
                            </NavLink>
                        )}

                    {all_roles &&
                        all_roles.includes('Linksurance - Orders') && (
                            <NavLink
                                to="/buildinsurance/orders/general"
                                className={({ isActive }) =>
                                    isActive
                                        ? styles.activeClassName
                                        : styles.inActiveClassName
                                }
                                onClick={closeMenu}
                            >
                                <ListItemButton>
                                    <ListItemText primary="Linksurance" />
                                </ListItemButton>
                            </NavLink>
                        )}

                    <NavLink
                        to="/chat"
                        className={({ isActive }) =>
                            isActive
                                ? styles.activeClassName
                                : styles.inActiveClassName
                        }
                        onClick={closeMenu}
                    >
                        <ListItemButton>
                            <ListItemText primary="Chat" />
                        </ListItemButton>
                    </NavLink>
                </Box>
            )}
        </AppBar>
    )
}

export default Navbar
